import cookies from 'browser-cookies'

export default ({ store }) => [
  {
    path: '/server',
    // component: DefaultLayout,
    async beforeEnter (to, from, next) {
      try {
        const authenticator = cookies.get('Authenticator')
        const token = cookies.get('Token')
        const refreshToken = cookies.get('RefreshToken')
        const user = await store.dispatch('passport/fetchUser', { token })
        await store.dispatch('passport/session', { authenticator, token, refreshToken, user })

        next({
          path: '/security/grant'
        })
      } catch (e) {
        next({
          path: '/security/signin'
        })
      }
    }
  }
]
